
const prescribedDrugsInformationSchema = {
  activeIngredient: {
    displayName: 'Princípio ativo',
    type: 'string',
    notAvailable: 'Não informado',
  },
  concentration: {  
    displayName: 'Concentração',
    type: 'string',
    notAvailable: 'Não informado',
  },
  doseFrequency: {
    displayName: 'Frequência da dose',
    type: 'string',
    notAvailable: 'Não informado',
  },
  doseFrequencyType: {
    displayName: 'Tipo de frequência da dose',
    type: 'string',
    notAvailable: 'Não informado',
  },
  doseDescription: {
    displayName: 'Descrição da dose',
    type: 'string',
    notAvailable: 'Não informado',
  },
  treatmentDuration: {
    displayName: 'Duração do tratamento (em dias)',
    type: 'number',
    notAvailable: 'Não informado',
  },
  administrationRoute: {
    displayName: 'Via de administração',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'administrationRoute',
  },
  isSingleDose: {
    displayName: 'Dose única',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  isContinuousDose: {
    displayName: 'Dose contínua',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  prescribedQuantity: {
    displayName: 'Quantidade prescrita',
    type: 'string',
    notAvailable: 'Não informado',
  },
  treatmentStartDate: {
    displayName: 'Data de início do tratamento',
    type: 'date',
    notAvailable: 'Não informado',
  },
  attendanceDateTime: {
    displayName: 'Data e hora do atendimento',
    type: 'datetime',
    notAvailable: 'Não informado',
    mask: 'datetime'
  },
  professionalName: {
    displayName: 'Nome do profissional de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  healthUnitName: {
    displayName: 'Nome da unidade de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  teamName: {
    displayName: 'Nome da equipe de saúde',
    type: 'string',
    notAvailable: 'Não informado',
  },
  weight: {
    displayName: 'Peso',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'weightKg',
  },
  height: {
    displayName: 'Altura',
    type: 'string',
    notAvailable: 'Não informado',
    mask: 'heightMeter',
  },
  typeOfAttendance: {
    displayName: 'Tipo de atendimento',
    type: 'string',
    notAvailable: 'Não informado',
  },
  isVaccinationUpToDate: {
    displayName: 'Vacinação em dia',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  lastMenstruationDate: {
    displayName: 'Data da última menstruação',
    type: 'date',
    notAvailable: 'Não informado',
  },
}

export default prescribedDrugsInformationSchema
